import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/views/jqueryView';

export default class OnlineVotingView extends JQueryView {
  constructor() {
    super('#online_voting_area');
    this.renderGeneralMeetingArea();
    this.renderChoicesFields();
  }

  @on({
    event: 'change',
    selector: 'input[name="company_ir[use_online_voting]"]:radio',
  })
  onChangeUseOnlineVoting() {
    this.renderGeneralMeetingArea();
  }

  renderGeneralMeetingArea() {
    const useOnlineVoting = $('input[name="company_ir[use_online_voting]"]')
      .filter(':checked')
      .val();

    if (useOnlineVoting === 'true') {
      $('#general_meeting_area').show();
      this.renderAgendaNumber();
    } else {
      $('#general_meeting_area').hide();
    }
  }

  @on({ event: 'change', selector: '.is_choice' })
  onChangeIsChoice() {
    this.renderChoicesFields();
  }

  renderChoicesFields() {
    const isChoices = $('input[id$=is_choice]');
    isChoices.each((_, checkbox) => {
      const choiceField = $(checkbox).parent().parent().next();
      if ($(checkbox).prop('checked')) {
        choiceField.show();
      } else {
        choiceField.hide();
      }
    });
  }

  renderAgendaNumber() {
    let agendaNumber = 1;
    $('.general-meeting-agenda-form').each((index, element) => {
      const $this = $(element);
      if (!$this.is(':hidden')) {
        $this
          .find('.agenda-number-input')
          .find('input')
          .attr('value', agendaNumber);
        $this
          .find('.agenda-number-view')
          .html(
            '<span class="font-weight-bold">' +
              '第' +
              agendaNumber +
              '号議案' +
              '</span>',
          );
        agendaNumber = agendaNumber + 1;
      }
    });
  }

  @on({ event: 'click', selector: '.add_agenda_fields' })
  onClickAddAgendaFields(event: JQuery.ClickEvent) {
    const link = $(event.currentTarget);
    const time = new Date().getTime();
    const regexp = new RegExp(link.data('id'), 'g');
    link.before(link.data('fields').replace(regexp, time));
    event.preventDefault();
    this.renderAgendaNumber();
    this.renderChoicesFields();
  }

  @on({ event: 'click', selector: '.remove_agenda_fields' })
  onClickRemoveAgendaFields(event: JQuery.ClickEvent) {
    const link = $(event.currentTarget);
    link.prev('input[type=hidden]').val('1');
    link.closest('fieldset').hide();
    event.preventDefault();
    this.renderAgendaNumber();
    this.renderChoicesFields();
  }
}
